export default "__VITE_ASSET__fe88ae2f__"